export default "__VITE_ASSET__e96f1870__"